<!-- prettier-ignore -->
<markdown ngPreserveWhitespaces>
  # Welcome to the Galaxy Framework

  The Galaxy frontend framework provides a set of presentational components that augment and improve on Angular Material, enabling advanced interfaces for enterprise applications and seamless integration with Vendasta's platform.
</markdown>

<img src="/assets/img/starry-sky.jpg" class="starry-sky-image" />

@for (menuGroup of siteMenu; track menuGroup) {
  <h4>{{ menuGroup.groupName }}</h4>
  <div class="table-scroll-wrapper">
    <table mat-table [dataSource]="menuGroup.links" class="component-list">
      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let link">
          @if (link.deprecated) {
            <glxy-badge [size]="'small'" [color]="'red'"> Deprecated </glxy-badge>
          }
          {{ link.name }}
        </td>
      </ng-container>
      <!-- Selector Column -->
      <ng-container matColumnDef="selector">
        <th mat-header-cell *matHeaderCellDef>Selector</th>
        <td mat-cell *matCellDef="let link">
          @if (link.selector) {
            <code>{{ link.selector }}</code>
          }
        </td>
      </ng-container>
      <!-- Code Done Column -->
      <ng-container matColumnDef="codeDone">
        <th mat-header-cell *matHeaderCellDef class="center-cell">Code</th>
        <td mat-cell *matCellDef="let link" class="center-cell">
          @if (link.codeDone === status.ToDo) {
            <mat-icon class="todo"> radio_button_unchecked </mat-icon>
          }
          @if (link.codeDone === status.Done) {
            <mat-icon class="done"> circle </mat-icon>
          }
          @if (link.codeDone === status.Partial) {
            <mat-icon class="partial"> tonality </mat-icon>
          }
          @if (link.codeDone === status.NotApplicable) {
            <span class="not-applicable"> n/a </span>
          }
        </td>
      </ng-container>
      <!-- Design Done Column -->
      <ng-container matColumnDef="designDone">
        <th mat-header-cell *matHeaderCellDef class="center-cell">Figma</th>
        <td mat-cell *matCellDef="let link" class="center-cell">
          @if (link.designDone === status.ToDo) {
            <mat-icon class="todo"> radio_button_unchecked </mat-icon>
          }
          @if (link.designDone === status.Done) {
            <mat-icon class="done"> circle </mat-icon>
          }
          @if (link.designDone === status.Partial) {
            <mat-icon class="partial"> tonality </mat-icon>
          }
          @if (link.designDone === status.NotApplicable) {
            <span class="not-applicable"> n/a </span>
          }
        </td>
      </ng-container>
      <!-- Guidelines Done Column -->
      <ng-container matColumnDef="guideDone">
        <th mat-header-cell *matHeaderCellDef class="center-cell">Guide</th>
        <td mat-cell *matCellDef="let link" class="center-cell">
          @if (link.guideDone === status.ToDo) {
            <mat-icon class="todo"> radio_button_unchecked </mat-icon>
          }
          @if (link.guideDone === status.Done) {
            <mat-icon class="done"> circle </mat-icon>
          }
          @if (link.guideDone === status.Partial) {
            <mat-icon class="partial"> tonality </mat-icon>
          }
          @if (link.guideDone === status.NotApplicable) {
            <span class="not-applicable"> n/a </span>
          }
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" [routerLink]="row.url"></tr>
    </table>
  </div>
}
